import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { MdDownloadForOffline } from 'react-icons/md';
import { AiTwotoneDelete } from 'react-icons/ai';
import { AiFillRobot } from 'react-icons/ai';
import { BsHeart, BsHeartFill } from 'react-icons/bs';
import { FaRegHeart, FaHeart } from 'react-icons/fa';

import { client, urlFor } from '../client';
import { fetchUser } from '../utils/fetchUser';

const Prompt = ({ prompt: { postedBy, image, _id, type, favourite, status}}) => {
  const [postHovered, setPostHovered] = useState(false);
  const navigate = useNavigate();
  const user = fetchUser();

  const alreadySaved = !!(favourite?.filter((item) => item?.postedBy?._id ===user?.sub))?.length;

  const savePrompt = (id) => {
    if(!alreadySaved) {

      client
        .patch(id)
        .setIfMissing({ favourite: [] })
        .insert('after', 'favourite[-1]', [{
          _key: uuidv4(),
          userId: user?.sub,
          postedBy: {
            _type: 'postedBy',
            _ref: user?.sub
          }
        }])
        .commit()
        .then(() => {
          window.location.reload();
        })
    }
  }

  const deletePrompt = (id) => {
    client
      .delete(id)
      .then(() => {
        window.location.reload();
      })
  }



  return (
    <div className='m-2'>
      <div
        onMouseEnter={() => setPostHovered(true)}
        onMouseLeave={() => setPostHovered(false)}
        onClick={() => navigate(`/prompt-detail/${_id}`)}
        className='relative cursor-zoom-in w-auto hover:shadow-lg rounded-lg overflow-hidden transition-all duration-500 ease-in-out'
        >
          {status == 'Approved' && (
          <img className='rounded-lg w-full' alt='user-post' src={urlFor(image).width(250).url()} />
          )}
          {status == 'Pending-Review' && (
          <img className='rounded-lg w-full opacity-50' alt='user-post' src={urlFor(image).width(250).url()} />
          )}
          {postHovered && status == 'Approved' && (
            <div
              className='absolute top-0 w-full h-full flex flex-col justify-between p-1 pr-2 pt-2 pb-2 z-50'
              style={{ height: '100%' }}
            >
              <div className='flex items-center justify-between'>
                <div className='flex gap-2'>
                <div className="badge badge-primary  ml-1 mt-1 pl-2 py-2 px-2 rounded-full text-xs uppercase tracking-widest mb-4 opacity-70">{type}</div>
                </div>
                {alreadySaved ? (
                  
                  <button className="btn btn-sm opacity-70 rounded-full">
                  <FaHeart size={15} />
                  </button>
                ): (
                  <button 
                    onClick={(e) => {
                      e.stopPropagation();
                      savePrompt(_id);
                    }}  
                  type='button' className='btn btn-sm btn-outline opacity-70 rounded-full'>
                    <FaRegHeart size={15} />
                  </button>
                  
                )}
              </div>
              <div className='flex justify-between items-center gap-2 ml-1 w-full'>
              <Link to={`/user-profile/${postedBy._id}`} onClick={(e) => e.stopPropagation()} className="flex gap-2 items-center opacity-70 hover:opacity-100">
              <img src={postedBy.image} onClick={(e) => e.stopPropagation()} className="w-7 h-7 rounded-full" alt="user-profile" />
              </Link>
                    
                  
              </div>
            </div>
          )}
          {postHovered && status == 'Pending-Review' && postedBy?._id === user?.sub && (
            <div
              className='absolute top-0 w-full h-full flex flex-col justify-between p-1 pr-2 pt-2 pb-2 z-50'
              style={{ height: '100%' }}
            >
              <div className='flex items-center justify-between'>
                <div className='flex gap-2'>
                <div className="badge badge-primary  ml-1 mt-1 pl-2 py-2 px-2 rounded-full text-xs uppercase tracking-widest mb-4 opacity-70">{status}</div>
                </div>
                {postedBy?._id === user?.sub && (
                    <button
                      type='button'
                      onClick={(e) => {
                        e.stopPropagation();
                        deletePrompt(_id);
                      }}
                      className='bg-red-100 p-2 text-red-700 opacity-70 hover:opacity-100 font-bold rounded-3xl hover:shadow-md outlined-none'  
                      >
                        <AiTwotoneDelete />
                      </button>
                  )}
              </div>
              <div className='flex justify-between items-center gap-2 ml-1 w-full'>
              
                  </div>

            </div>
          )}
      </div>


    </div>

    
  )
}

/*
For posted by profile pic and name
<Link to={`user-profile/${postedBy?._id}`} className='flex gap-2 mt-2 items-center'>
          <img
            className='w-8 h-8 rounded-full object-cover'
            src={postedBy?.image}
            alt='user-profile'
          />
          <p className='font-semibold capitalize'>{postedBy?.userName}</p>
      </Link>

      Delete icon to delete own upload

        const deletePrompt = (id) => {
    client
      .delete(id)
      .then(() => {
        window.location.reload();
      })
  }

  
{postedBy?._id === user?.sub && (
                    <button
                      type='button'
                      onClick={(e) => {
                        e.stopPropagation();
                        deletePrompt(_id);
                      }}
                      className='bg-white p-2 opacity-70 hover:opacity-100 font-bold text-dark text-base rounded-3xl hover:shadow-md outlined-none'  
                      >
                        <AiTwotoneDelete />
                      </button>
                  )}

                  {favourite?.length} 


                                    <div className="inline-block ml-1 pl-2 py-1 px-2 rounded-full bg-blue-50 text-blue-500 text-xs font-medium tracking-widest uppercase">
                    {type}
                    </div>
      */

                    /*
<button type='button' className='bg-white flex items-center gap-2 text-black font-bold p-2 pl-4 pr-4 rounded-full opacity-70 hover:100 hover:shadow-md'>
                   <BsHeartFill  />
                  </button>
                    */



                  // {postedBy?._id === user?.sub && (
                  //   <button
                  //     type='button'
                  //     onClick={(e) => {
                  //       e.stopPropagation();
                  //       deletePrompt(_id);
                  //     }}
                  //     className='bg-red-100 p-2 text-red-700 opacity-70 hover:opacity-100 font-bold rounded-3xl hover:shadow-md outlined-none'  
                  //     >
                  //       <AiTwotoneDelete />
                  //     </button>
                  // )}
export default Prompt